import hasFeature from 'modules/core/lib/hasFeature'
import i18n from 'modules/core/lib/i18n'

export const STREAM_MODEL = 'Company'

export const TOTAL_SPAN = 27

export const PAGE_SIZE = 20

export const EVENT_TYPE = 'event_type'

export const DATE_FROM = 'date_from'

export const DATE_TO = 'date_to'

export const BECOME_CONTEXT = 'become'

export const getTitles = () => {
  const columns = [
    {
      name: i18n.t('settings.audit_log.header.author'),
      colSpan: 5,
    },
    {
      name: i18n.t('settings.audit_log.header.event_name'),
      colSpan: 5,
    },
    {
      name: i18n.t('settings.audit_log.header.target'),
      colSpan: 5,
    },
    {
      name: i18n.t('settings.audit_log.header.date'),
      colSpan: 5,
    },
    {
      name: '',
      colSpan: 2,
    },
  ]

  if (hasFeature('become_enabled')) {
    columns.splice(2, 0, {
      name: i18n.t('settings.audit_log.header.become_user'),
      colSpan: 5,
    })
  }

  return columns
}

export type Audit = {
  id: string
  context: string
  date: string
  access_id: number
  data: {
    snapshot?: {
      access_id?: number
      employee_id?: number
    }
    [key: string]: unknown
  }
  event_name: string
  become_id?: number
}

export interface State {
  fromId: string | null | undefined
  direction: 'backward' | 'forward'
  isPreviousPage: boolean
  pageChanged: boolean
  loading: boolean
  eventsData: {
    audits: Audit[]
    newest_audit: Audit | null
    has_next_page: boolean
  }
  applyFilters: boolean
  isFirstLoad: boolean
}
